import { CanActivateFn, Router } from '@angular/router';
import { hasAuthToken } from '../../auth/services/auth.utils';
import { inject } from '@angular/core';
import { paymentDidSuccessRedirect } from '@payment/utils';
import { SubscriptionStore } from '@stores/subscription.store';
import { UserStore } from '@stores/user.store';
import { NativeAppService } from '../../core/services/native-app/native-app.servece';
import { AuthService } from '../../auth/services/auth.service';

export const InAppPaymentGuard: CanActivateFn = async route => {
  const userStore = inject(UserStore);
  const subscriptionStore = inject(SubscriptionStore);
  const router = inject(Router);
  const nativeApp = inject(NativeAppService);
  const authService = inject(AuthService);
  const apiKey = route.queryParamMap.get('ApiKey') || route.queryParamMap.get('apiKey');

  if (apiKey) {
    await authService.exchangeAndStoreApiKey(apiKey);
  }

  if (hasAuthToken()) {
    userStore.waitForLoading().then();
    if (
      route.data.requiresPromotionEligibility &&
      !paymentDidSuccessRedirect() &&
      !(await subscriptionStore.waitForPromotionEligibility())
    ) {
      if (nativeApp.isInsideNativeApp()) {
        nativeApp.closePopup();
        return false;
      }
      return router.parseUrl('/app/home');
    }
    return true;
  }

  nativeApp.closePopup();
  return false;
};
